import type { BridgeMessageHandler } from '../message-router.js';

export const handleAuthToken: BridgeMessageHandler<'auth_token'> = (msg, { log }) => {
  if (typeof msg.token !== 'string') return;
  log('Received auth token. Save it for future runs:');
  log(`  export BUILDAUTOMATON_AUTH_TOKEN="${msg.token}"`);
};
